import { Layout, Popover, message, Select } from 'antd'
import FontIcon from '../components/YhIcon'
// import { useHistory } from 'react-router-dom'
import useGlobalModel from '../model/globalModel'
// import useNavModel from '../model/navModel'
import { CaretDownOutlined } from '@ant-design/icons'
import { loginServiceAuth2 } from '@/views/login/LoginServiceAuth2'
import { setToken } from '@/utils/constants'
import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import logo from '@/assets/images/favicon.png'
import logo1 from '@/assets/images/favicon1.png'

const { Header } = Layout

function ScmHeader() {
    // const history = useHistory()
    const { user, setUser, dealerNameData } = useGlobalModel()
    // const { initNav } = useNavModel(() => [])

    const [currentDateTime, setCurrentDateTime] = useState(new Date())

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentDateTime(new Date())
        }, 1000)

        return () => {
            clearInterval(intervalId)
        }
    }, [])
    // 然后通过 setInterval 来进行定时刷新
    useEffect(() => {
        const timer = setInterval(async () => {
            let { retData: newToken }: any = await loginServiceAuth2.getToken()
            setToken(newToken.token)
            setUser({ ...user, token: newToken.token })
        }, 3600000)
        return () => clearInterval(timer)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    //退出登录
    const onLogout = async () => {
        // setUser({ ...user, shopId: '', shopName: '', shopCode: '', token: '' })
        // initNav()
        // history.push('/login')
        await message.success('已退出登录！')
        window.localStorage.clear()
        window.sessionStorage.clear()
        window.location.reload()
    }

    const content = (
        <div onClick={() => onLogout()} style={{ cursor: 'pointer', fontSize: '14px', color: 'rgba(0,0,0,0.65)' }}>
            <FontIcon type="icon-tuichu" style={{ marginRight: '3px' }} />
            <span>安全退出</span>
        </div>
    )
    const REACT_APP_ENV = process.env.REACT_APP_ENV as 'DEV' | 'TEST' | 'PROD' | 'STAGE'
    return (
        <Header className="layout-section-header">
            <div className="header-right" style={{ paddingRight: '15px' }}>
                <span style={{ borderRight: ' 1px solid rgba(98, 98, 98, 0.5)', padding: '0 20px' }}>
                    {dayjs(currentDateTime.toLocaleString()).format('YYYY年MM月DD日 HH:mm:ss')}
                </span>
                {dealerNameData?.length > 0 && (
                    <span style={{ borderRight: ' 1px solid rgba(98, 98, 98, 0.5)', padding: '0 20px', display: 'inline-flex', alignItems: 'center' }}>
                        <Select
                            size="small"
                            style={{ width: 160 }}
                            value={user.createUser}
                            options={dealerNameData?.map((item: any) => ({ label: item.label ?? item.name ?? item, value: item.value ?? item.name ?? item }))}
                            onChange={(value) => {
                                setUser({ ...user, createUser: value })
                                window.location.reload()
                            }}
                        />
                    </span>
                )}
                <Popover content={content}>
                    <span
                        onClick={(e) => e.preventDefault()}
                        style={{
                            marginLeft: '20px',
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'nowrap',
                            alignItems: 'center',
                        }}
                    >
                        <img alt="" src={REACT_APP_ENV === 'PROD' ? logo1 : logo} style={{ width: '47px', marginRight: '7px' }} />
                        <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'nowrap' }}>
                            <span>欢迎您！</span>
                            <span>{user.userName ?? '未获取到'}</span>
                        </div>
                        <CaretDownOutlined style={{ marginLeft: '10px' }} />
                    </span>
                </Popover>
            </div>
        </Header>
    )
}

export default ScmHeader
